module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "irecordlist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "editor"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "选择编辑"
    },
    on: {
      "change": _vm.handleUserChange
    },
    model: {
      value: (_vm.filters.editor),
      callback: function($$v) {
        _vm.$set(_vm.filters, "editor", $$v)
      },
      expression: "filters.editor"
    }
  }, _vm._l((_vm.formatUsers), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('emptyCont', {
    attrs: {
      "show": !_vm.getNewsdataLen
    }
  }), _vm._v(" "), _c('contentList', {
    attrs: {
      "newsdata": _vm.formatNewsData,
      "labelname": _vm.label,
      "goUrl": _vm.goEdit,
      "limit": _vm.limit,
      "total": _vm.newstotal,
      "tipshow": "tipshow",
      "handlePageChange": _vm.handlePageChange,
      "urladdr": _vm.linkpath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.newstotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77584d98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/irecord/list.vue
// module id = 768
// module chunks = 6